import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetProgress,
	GetProgressParams,
	GetProgressResponse,
} from 'domain/usecases/private/profile/get-progress';

export class RemoteGetProgress implements GetProgress {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetProgressResponse>,
	) {}

	async get({signal, ...params}: GetProgressParams): Promise<GetProgressResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
